module.exports = __webpack_public_path__ + "img/system2.aba9f2f1.png";